
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resumes/[segment]",
      function () {
        return require("private-next-pages/resumes/[segment]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resumes/[segment]"])
      });
    }
  